/**
 * "Continue with Google" button — doctor-facing.
 *
 * Redirects to Emergent's managed Google Auth URL. The redirect URL is
 * derived from window.location.origin so it works on any environment
 * (preview, production, local) without env vars.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function GoogleSignInButton({ label = "Continue with Google", testId = "google-signin-btn" }) {
    const onClick = () => {
        const redirectUrl = window.location.origin + "/auth/google/callback";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };
    return (
        <button
            type="button"
            onClick={onClick}
            data-testid={testId}
            className="w-full flex items-center justify-center gap-3 border border-[#DADCE0] bg-white text-[#3C4043] text-sm font-semibold h-11 rounded-md hover:bg-[#F8F9FA] hover:shadow-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#4285F4]/30"
        >
            <GoogleGlyph />
            <span>{label}</span>
        </button>
    );
}

function GoogleGlyph() {
    // Official Google "G" — inline SVG so we don't ship an image asset.
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path
                fill="#4285F4"
                d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615Z"
            />
            <path
                fill="#34A853"
                d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z"
            />
            <path
                fill="#FBBC05"
                d="M3.964 10.707A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.707V4.961H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.039l3.007-2.332Z"
            />
            <path
                fill="#EA4335"
                d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.961L3.964 7.293C4.672 5.166 6.656 3.58 9 3.58Z"
            />
        </svg>
    );
}
